<template>
    <div v-for="variation in product.variations">
        <label :for="`variation_${variation.id}`">{{variation.title}}</label>
        <select :name="`variation_${variation.id}`" :id="`variation_${variation.id}`"
            :value="getAttributeEntity(variation.id)"
            @change="(e) => {setAttributeEntity(variation.id, e.target.value);}"
        >
            <option
                v-for="entity in variation.entities"
                :value="entity.id"
                :disabled="attributeEntityIsDisabled(variation.id, entity.id)"
            >
                {{variation.prefix ? variation.prefix + ' ' : ''}}
                {{entity.value}}
                {{variation.suffix ? variation.suffix + ' ' : ''}}
            </option>
        </select>
    </div>
</template>

<script>
import {ProductMixin} from "./ProductMixin";

export default {
    name: "Variations",
    mixins: [ProductMixin],
    data() {
        return {
            selected_attributes: {},
            available_attribute_entities: {},
            selected_variable: null
        }
    },
    computed: {
    },
    methods: {
        /**
         * Add available attribute entities ti this.available_entities based on
         * product variables and selected attributes
         */
        handleAvailableEntities() {
            this.product.variations.map(variation => {
                console.log(variation);
                let availableEntities = [];
                this.product.variables.filter(variable => {
                    console.log(variable);
                    let variable_is_qualified = true;
                    let is_selected_variable = true;
                    Object.entries(this.selected_attributes).map(selected_attribute => {
                        const selected_attribute_id = Number(selected_attribute[0].substring(5));
                        variable.attribute_entities.map(variable_entity => {
                            if (
                                variation.id !== selected_attribute_id
                                &&
                                variable_entity.attribute_id === selected_attribute_id
                                &&
                                variable_entity.id !== selected_attribute[1]
                            ) {
                                variable_is_qualified = false;
                            }
                            if (
                                selected_attribute_id === variable_entity.attribute.id
                                &&
                                selected_attribute[1] !== variable_entity.id
                            ) {
                                is_selected_variable = false;
                            }
                        });
                    });
                    if (is_selected_variable) {
                        this.selected_variable = variable.id;
                    }
                    return variable_is_qualified;
                }).map(variable => {
                    variable.attribute_entities.map(entity => {
                        availableEntities.push(entity.id);
                    });
                });
                this.available_attribute_entities['attr_'+variation.id] = availableEntities;
            });
        },
        attributeEntityIsDisabled(attribute_id, entity_id) {
            if (typeof this.available_attribute_entities['attr_'+attribute_id] !== "undefined") {
                return this.available_attribute_entities['attr_'+attribute_id].indexOf(entity_id) === -1;
            }
            return false;
        },
        /**
         * Handle default selected attributes based on default variable
         * */
        handleSelectedAttributes() {
            this.product.variables[0].attribute_entities.map(entity => {
                this.product.variations.map(variation => {
                    if (entity.attribute_id === variation.id) {
                        this.setAttributeEntity(entity.attribute_id, entity.id);
                    }
                })
            });
        },
        /**
         * Get selected attribute entity of a specific attribute
         */
        getAttributeEntity(attribute_id) {
            if (typeof this.selected_attributes['attr_'+attribute_id] !== undefined) {
                return this.selected_attributes['attr_'+attribute_id];
            }
            return null;
        },
        /**
         * Set selected attribute entity of a specific attribute
         */
        setAttributeEntity(attribute_id, entity_id) {
            this.selected_attributes['attr_'+attribute_id] = Number(entity_id);
            this.handleAvailableEntities();
        },
    },
    watch: {
        isLoaded(value) {
            if (value) {
                this.handleSelectedAttributes();
            }
        },
        selected_variable(value) {
            this.$store.commit('product/setSelectedVariableId', value);
        }

    }
}
</script>

<style scoped>

</style>
